import { Component, OnInit } from '@angular/core';
import {ListeParution} from '../../../../../model/liste/ListeParution';
import {ListeParutionService} from '../../../../../service/interne/parution/ListeParutionService';
import {ActivatedRoute, Router} from '@angular/router';
import {FormatIntranetShareService} from '../../../../../service/partage/prototype/FormatIntranetShareService';
import {Parution} from '../../../../../model/parution/Parution';
import {ParutionService} from '../../../../../service/interne/parution/parutionService';
import {DialogueShareService} from '../../../../../service/partage/utilitaire/DialogueShareService';
import {ListeParutionParution} from '../../../../../model/liste/ListeParutionParution';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
  selector: 'app-escal-liste-parution-fiche',
  templateUrl: './escal-liste-parution-fiche.component.html',
  styleUrls: ['./escal-liste-parution-fiche.component.scss'],
  providers: [ ListeParutionService, ParutionService ]
})
export class EscalListeParutionFicheComponent implements OnInit {

  private sub: any;
  listeParution: ListeParution;
  auteurAncienId: number;
  parutionsAssocies: Array<Parution>;
  assosListeParution: Array<ListeParutionParution>;
  maxPage: number;
  curentPage: number;
  total: number;
  fakeArray: Array<any>;
  commentaires: string;
  nbCaracteres: number;
  afficher: string;
  listeDesassocier: Array<any> = [];
  constructor(private listeParutionService: ListeParutionService, private route: ActivatedRoute,
              public formatIntranetShareService: FormatIntranetShareService, private parutionService: ParutionService,
              private dialogueShareService: DialogueShareService, private router: Router, private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.auteurAncienId = 0;
    this.curentPage = 1;
    this.commentaires = '';
    this.nbCaracteres = 0;
    this.afficher = 'moins';
    this.sub = this.route.params.subscribe(params => {
      this.listeParutionService.getListeParutionDetails(params.id)
        .then((listeParution) => {
          this.listeParution = listeParution as ListeParution;
          // récupérer l'ancien id de l'auteur pour le lien vers sa fiche intranet
          if (this.listeParution.auteur != null) {
            this.listeParutionService.getAncienIdAuteur(this.listeParution.id).then((retour) => {
              if (retour !== 0) {
                this.auteurAncienId = retour;
              }
            });
          }
          // adapter l'affichage du commentaire si trop long
          if (this.listeParution.commentaires != null) {
            this.nbCaracteres = this.listeParution.commentaires.length;
            this.commentaires = this.listeParution.commentaires.substr(0, 100);
          }
          this.listeParutionService.getAllParutionsListe(this.listeParution.id, this.curentPage).then((parutions) => {
            this.parutionsAssocies = parutions['hydra:member'] as Array<Parution>;
            this.total = parutions['hydra:totalItems'];
            this.getMaxPage(parutions['hydra:totalItems']);
            this.fakeArray = new Array(this.maxPage);
          });
        });
    });
  }

  getMaxPage(nbElement) {
    this.maxPage = Math.trunc(nbElement / 10);
    if (nbElement % 10 !== 0) {
      this.maxPage = this.maxPage + 1;
    }
  }

  accesPage() {
    this.listeParutionService.getAllParutionsListe(this.listeParution.id, this.curentPage).then((parutions) => {
      this.parutionsAssocies = parutions['hydra:member'] as Array<Parution>;
      this.total = parutions['hydra:totalItems'];
      this.getMaxPage(parutions['hydra:totalItems']);
      this.fakeArray = new Array(this.maxPage);
    });
  }

  pageMoins() {
    if (this.curentPage > 0) {
      this.curentPage = Number(this.curentPage) - 1;
      this.listeParutionService.getAllParutionsListe(this.listeParution.id, this.curentPage).then((parutions) => {
        this.parutionsAssocies = parutions['hydra:member'] as Array<Parution>;
        this.total = parutions['hydra:totalItems'];
        this.getMaxPage(parutions['hydra:totalItems']);
        this.fakeArray = new Array(this.maxPage);
      });
    }
  }

  pagePlus() {
    if (this.curentPage < this.maxPage) {
      this.curentPage = Number(this.curentPage) + 1;
      this.listeParutionService.getAllParutionsListe(this.listeParution.id, this.curentPage).then((parutions) => {
        this.parutionsAssocies = parutions['hydra:member'] as Array<Parution>;
        this.total = parutions['hydra:totalItems'];
        this.getMaxPage(parutions['hydra:totalItems']);
        this.fakeArray = new Array(this.maxPage);
      });
    }
  }

  changerAffichage() {
    if (this.afficher === 'plus') {
      this.commentaires = this.listeParution.commentaires.substr(0, 100);
      this.afficher = 'moins';
    } else {
      this.commentaires = this.listeParution.commentaires;
      this.afficher = 'plus';
    }
  }

  supprimerListe() {
    this.dialogueShareService.addDialogue('Supprimer la liste ?', () => {
      this.spinner.show();
      // supprimer les associations avant de supprimer la liste
      // pour chaque parution associée on supprime l'asso
      this.assosListeParution = [];
      this.listeParutionService.getAllAssosListeParution(this.listeParution.id).then(async (assos) => {
        this.assosListeParution = assos['hydra:member'] as Array<ListeParutionParution>;
        if (this.assosListeParution != null) {
          for (const assosListeParution of this.assosListeParution) {
            await this.listeParutionService.supprimerAssoListeParution(assosListeParution.id).then(() => {
            });
          }
        }
        // supprimer liste dans la base intranet
        await this.listeParutionService.supprimerImportListeParutionIntranet(this.listeParution.ancienId)
          .then(async () => {
            // supprimer liste d'escalnet
            await this.listeParutionService.supprimerListeParution(this.listeParution.id).then((liste) => {
              this.spinner.hide();
              this.router.navigate(['/escal/listes/parution']);
              this.dialogueShareService.addDialogue('La liste a bien été supprimée');
            });
          });
      });
    });
  }

  ajouterListeDesassocier(parutionId) {
    let parutionPresente;
    if (parutionId != 0) {
      parutionPresente = this.listeDesassocier.find(element => element == parutionId);
      if (parutionPresente === undefined) {
        // si pas dans la liste, on l'ajoute
        this.listeDesassocier.push(parutionId);
      } else {
        // si dans la liste, on l'enlève
        this.listeDesassocier = this.listeDesassocier.filter(element => element != parutionId);
      }
    }
  }

  async supprimerAssociation() {
    if (this.listeDesassocier.length > 0) {
      this.dialogueShareService.addDialogue('Désassocier ces parutions ?', async () => {
        for (const contactId of this.listeDesassocier) {
          await this.listeParutionService.getOneAssoParutionListe(this.listeParution.id, contactId).then(async (asso) => {
            if (asso['hydra:member'][0] != undefined && asso['hydra:member'][0] != null) {
              await this.listeParutionService.deleteParutionAssoIntranet(asso['hydra:member'][0].id).then(async () => {
                await this.listeParutionService.supprimerAssoListeParution(asso['hydra:member'][0].id).then(async () => {
                });
              });
            }
          });
        }
        await this.dialogueShareService.addDialogue('Les parutions ont bien été désassociées');
        await this.ngOnInit();
      });
    } else {
      this.dialogueShareService.addDialogue('Aucune parution sélectionnée');
    }
  }

}
